import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import {
    renderField,
    renderCheckbox,
    required,
    renderTextArea,
    number,
    minValue,
} from "../../../../utils/formValidations.js";
import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";

const minValue50 = minValue(50);

class GcpProviderFormTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentProvider: {},
        };
        this.submitApi = this.submitApi.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
    }

    componentDidMount() {
        if (this.props.current_provider) {
            this.props.initialize({
                vm_provider_config_name: this.props.current_provider.vm_provider_config_name,
                vm_provider_name: this.props.current_provider.vm_provider_name,

                max_instances: this.props.current_provider.max_instances,
                gcp_project: this.props.current_provider.gcp_project,
                gcp_region: this.props.current_provider.gcp_region,
                gcp_zone: this.props.current_provider.gcp_zone,
                gcp_machine_type: this.props.current_provider.gcp_machine_type,
                gcp_image: this.props.current_provider.gcp_image,
                startup_script: this.props.current_provider.startup_script,
                gcp_boot_volume_gb: this.props.current_provider.gcp_boot_volume_gb,
                gcp_cmek: this.props.current_provider.gcp_cmek,
                gcp_disk_type: this.props.current_provider.gcp_disk_type,
                gcp_network: this.props.current_provider.gcp_network,
                gcp_subnetwork: this.props.current_provider.gcp_subnetwork,
                gcp_public_ip: this.props.current_provider.gcp_public_ip,
                gcp_network_tags: this.props.current_provider.gcp_network_tags,
                gcp_custom_labels: this.props.current_provider.gcp_custom_labels,
                gcp_credentials: this.props.current_provider.gcp_credentials,
                gcp_metadata: this.props.current_provider.gcp_metadata,
                gcp_service_account: this.props.current_provider.gcp_service_account,
                gcp_guest_accelerators: this.props.current_provider.gcp_guest_accelerators,
                gcp_config_override: this.props.current_provider.gcp_config_override,
            });
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
            this.props.initialize({
                vm_provider_config_name: nextProps.current_provider.vm_provider_config_name,
                vm_provider_name: nextProps.current_provider.vm_provider_name,

                max_instances: nextProps.current_provider.max_instances,
                gcp_project: nextProps.current_provider.gcp_project,
                gcp_region: nextProps.current_provider.gcp_region,
                gcp_zone: nextProps.current_provider.gcp_zone,
                gcp_machine_type: nextProps.current_provider.gcp_machine_type,
                gcp_image: nextProps.current_provider.gcp_image,
                startup_script: nextProps.current_provider.startup_script,
                gcp_boot_volume_gb: nextProps.current_provider.gcp_boot_volume_gb,
                gcp_cmek: nextProps.current_provider.gcp_cmek,
                gcp_disk_type: nextProps.current_provider.gcp_disk_type,
                gcp_network: nextProps.current_provider.gcp_network,
                gcp_subnetwork: nextProps.current_provider.gcp_subnetwork,
                gcp_public_ip: nextProps.current_provider.gcp_public_ip,
                gcp_network_tags: nextProps.current_provider.gcp_network_tags,
                gcp_custom_labels: nextProps.current_provider.gcp_custom_labels,
                gcp_credentials: nextProps.current_provider.gcp_credentials,
                gcp_metadata: nextProps.current_provider.gcp_metadata,
                gcp_service_account: nextProps.current_provider.gcp_service_account,
                gcp_guest_accelerators: nextProps.current_provider.gcp_guest_accelerators,
                gcp_config_override: nextProps.current_provider.gcp_config_override,
            });
        }
    }


    cancelButton() {
        this.props.cancel_button(userData)
    }

    submitApi(userData) {
        userData.vm_provider_name = "gcp"
        this.props.submit_api(userData)
    }

    render() {
        const { handleSubmit } = this.props;
        const { currentZone } = this.state;
        const gcp_public_ip_checked = currentZone && currentZone.gcp_public_ip;

        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="vm_provider_config_name" className="requiredasterisk">Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="vm_provider_config_name"
                                    id="vm_provider_config_name"
                                    component={renderField}
                                    validate={required}
                                    placeholder="Example Google Cloud Config"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_credentials" className="requiredasterisk">GCP Credentials (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_credentials"
                                    id="gcp_credentials"
                                    placeholder='{"foo" : "bar"}'
                                    component={renderTextArea}
                                    validate={required}
                                />
                            </Col>

                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="max_instances" className="requiredasterisk">Max Instances</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="number"
                                    name="max_instances"
                                    id="max_instances"
                                    placeholder="10"
                                    component={renderField}
                                    validate={number}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_project" className="requiredasterisk">Project ID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_project"
                                    id="gcp_project"
                                    placeholder="project-name"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_region" className="requiredasterisk">Region</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_region"
                                    id="gcp_region"
                                    placeholder="us-east4"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_zone" className="requiredasterisk">Zone</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_zone"
                                    id="gcp_zone"
                                    placeholder="us-east4-b"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_machine_type" className="requiredasterisk">Machine Type</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_machine_type"
                                    id="gcp_machine_type"
                                    placeholder="e2-standard-2"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_image" className="requiredasterisk">Machine Image</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_image"
                                    id="gcp_image"
                                    placeholder="projects/debian-cloud/global/images/debian-10-buster-v20211209"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_boot_volume_gb" className="requiredasterisk">Boot Volume GB</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_boot_volume_gb"
                                    id="gcp_boot_volume_gb"
                                    placeholder="50"
                                    component={renderField}
                                    validate={[number, minValue50]}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_disk_type" className="requiredasterisk">Disk Type</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_disk_type"
                                    id="gcp_disk_type"
                                    placeholder="pd-ssd"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_cmek">Customer Managed Encryption Key (CMEK)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_cmek"
                                    id="gcp_cmek"
                                    placeholder="projects/project-name/locations/global/keyRings/my-keyring/cryptoKeys/my-key"
                                    component={renderField}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_network" className="requiredasterisk">Network</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_network"
                                    id="gcp_network"
                                    placeholder="projects/project-name/global/networks/default"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_subnetwork" className="requiredasterisk">Sub Network</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_subnetwork"
                                    id="gcp_subnetwork"
                                    placeholder="projects/project-name/regions/us-east4/subnetworks/default"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_public_ip" className="requiredasterisk">Public IP</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                    name="gcp_public_ip"
                                    id="gcp_public_ip"
                                    checked={gcp_public_ip_checked}
                                    component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_network_tags">Network Tags (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_network_tags"
                                    id="gcp_network_tags"
                                    placeholder='["https-server"]'
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_custom_labels">Custom Labels (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_custom_labels"
                                    id="gcp_custom_labels"
                                    placeholder='{"foo" : "bar"}'
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_metadata">Metadata (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_metadata"
                                    id="gcp_metadata"
                                    placeholder='[{}]'
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_service_account">Service Account (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_service_account"
                                    id="gcp_service_account"
                                    placeholder='{}'
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_guest_accelerators">Guest Accelerators (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_guest_accelerators"
                                    id="gcp_guest_accelerators"
                                    placeholder='[]'
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_config_override">GCP Config Override (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_config_override"
                                    id="gcp_config_override"
                                    placeholder='{}'
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="startup_script" className="requiredasterisk">Startup Script</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="startup_script"
                                    id="startup_script"
                                    placeholder="#!/bin/bash&#10;..."
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="button" size="sm"
                            className="cancel-button"
                            color="basic" onClick={() => this.props.cancel_button()}>{this.props.wizard ? 'Previous' : 'Cancel'}</Button>
                        <Button type="submit"
                            className="submit-button"
                            size="sm" color="primary">{!this.props.wizard ? 'Submit' : this.props.stepCount && this.props.stepCount > 2 ? 'Next' : 'Finish'}</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

GcpProviderFormTemplate.propTypes = {
    current_provider: Proptypes.object,
    submit_api: Proptypes.func.isRequired,
    handleSubmit: Proptypes.func,
    cancel_button: Proptypes.func,
};

let GcpProviderFormWithRouter = withRouter(GcpProviderFormTemplate);

let GcpProviderForm = connect(state => {

    return {
        vm_provider_configs: state.vm_provider.vm_provider_configs,
    }
},

    dispatch =>
    ({

    }))(GcpProviderFormWithRouter);

export default reduxForm({
    form: "VmProviderForm",
})(GcpProviderForm);
